import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConsts } from 'src/app/common/app-consts';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import { SaveVehicleNotifyRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { GVehicleNotifyViewModel } from 'src/app/viewmodels/g-vehicle/GVehicleNotifyViewModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-vehicle-notify',
  templateUrl: './vehicle-notify.component.html',
  styleUrls: ['./vehicle-notify.component.scss']
})
export class VehicleNotifyComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  public component_Title = 'Vechicle Notify';
  public vmListItems: any = [];
  public statusListItems: any = [];
  public SortBy: string = "asc";

  public itemVm: SaveVehicleNotifyRequest = new SaveVehicleNotifyRequest();
  dataTable: any;
  dtOption: any = {};
  public exportFormat: string = 'csv';
  public vehicleStatus: number = 0;
  startDate: any = null;
  endDate: any = null;
  public attachmentList: any = [];

  public deleteId: string;
  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
    $('table.display').DataTable();

    //   this.getList();
    //   this.dtOption = {
    //     "paging":   false,
    //     "searching": false,
    //     "info": false,
    // };
    // $(() =>{
    //   $('table.display').DataTable(this.dtOption);
    // })
  }

  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
      this.modalRefLv1.setClass('modal-lg');
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
    if (lvl == 3) {
      this.modalRefLv3 = this._modalService.show(template);
    }
  }

  ngAfterViewInit() {
    // this._jq.showSpinner();
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSettingService.getList("GSetting", "GetVehicleNotifiesAsync", this.p, this.size, search, this.orderBy, this.sort)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }

  // getList() {
  //   // this._jq.showSpinner(true);
  //   debugger
  //   this.spinner.show();
  //   this._uow.vehicleNotifyService.GetPagedResult().subscribe((res: any) => {
  //     this.vmListItems = res;
  //     console.log(res);
  //     debugger
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Network Issue!',
  //       'error'
  //     )
  //   });
  // }

  // getSortIndexList(sIndex) {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.vehicleNotifyService.GetPagedResultBySort(0, 50, AppConsts.VEHICLE, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res;;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //   });
  // }

  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.vehicleNotifyService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p = 1;
  //     this.vmListItems = res;
  //       // this._jq.showSpinner();
  //     this.spinner.hide();
  //     }, (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //     this.spinner.hide();

  //     });
  //   }
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveVehicleNotifyRequest();
    }
  }
  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gSettingService.DeleteVehicleNotifyAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRefLv1.hide();
      this.spinner.hide();
    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }

  // external components
  onItemSubmitted(e) {
    debugger
    if (e == true) {
      this.modalRefLv1.hide();
      this.getList();
      this._jq.showSpinner(false);
    }
  }


  openExportModel(template: TemplateRef<any>) {
    this.openModal(template, 1);
  }


  exportToExcel() {
    debugger;
    this.spinner.show();
    this._uow.gSettingService.GetVehicleNotifyExportAsync(this.startDate, this.endDate).subscribe(
      (res: any) => {
        debugger;
        this.openLinkInNewTab(res.file);
        this.spinner.hide();

      },
      (error) => {
        this.spinner.hide();
        this._uow.logger.log(error);
        Swal.fire(
          'Failure!',
          'Records was not found.',
          'error'
        )
      }
    );
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }



  openAttachmentModal(template: TemplateRef<any>, b: any) {
    debugger;
    // Filter and map attachments where Id matches b
    this.attachmentList = this.vmListItems.reduce((acc, item) => {
      // Filter attachments with matching Id
      const attachments = item.listOfAttachment
        .filter(att => att.fkVehicleNotifyId === b) // Filter condition
        .map(att => att.attachment); // Map to extract Attachment
      return acc.concat(attachments);
    }, []);

    this.modalRefLv2 = this._uow.modalServiceEx.show(template);
    this.modalRefLv2.setClass('modal-lg');
  }

   
}
